{#await promise}
  <DropdownSkeleton />
{:then data}
  <Dropdown
    type="inline"
		light
		itemToString={(item) => {
			return `[${item.code}] - ${item.text}`
		}}
    selectedIndex={selectIdx}
    items={data}
		on:select={(e)=>handleSelect(e)}
  />
{/await}

<!-- <style lang="scss" global>
	/** Gray 10 theme **/
  @import "carbon-components-svelte/css/g90";
</style> -->

<script>
	import { get } from 'svelte/store'
	import auth from '../../helpers/auth.js'
	import { navigate } from 'svelte-routing'
	
	import { Firestore } from '../../config/firebase'
  
  import { Dropdown, DropdownSkeleton } from "carbon-components-svelte"

	const user = get(auth)

	let selectIdx = 0
	let promise = getClients()

	const handleSelect = async (e) => {
		await auth.setClient(e.detail.selectedItem)
		selectIdx = e.detail.selectedIndex
		// alert(`selected Item => ${JSON.stringify(e.detail.selectedItem,null,2)}`)
		// {"selectedId":"neMXuH4I1SYDQoN9IioI","selectedIndex":1,"selectedItem":{"id":"neMXuH4I1SYDQoN9IioI","text":"DNAIQ","code":"DNAIQ"}}
		// navigate(`/`)
		window.history.go(0)
	}

	async function getClients() {
		// console.log(`getting clients...`)
		let clients = []
		try { 
			let snap = await Firestore.collection(`userMeta`)
												.doc(user.uid)
												.collection('userClients')
												.get()
			let idx = 0
			snap.forEach( doc => {
				// console.log(`userClient => ${JSON.stringify(doc.data(),null,2)}`)
        let dd = doc.data()  // dd = Doc Data
        let data = {}
				data.id = doc.id
				if (doc.id == user.clientID) {selectIdx = idx}
				data.text = dd.client.name
				data.code = dd.client.code
				clients.push(data)
				idx = idx+1
			})
		} catch (error) {
			console.log("Error getting documents: ", error)
		}
		// console.log(JSON.stringify(clients,null,2))
		return clients
	}
</script>